




import Vue from 'vue'
import Component from 'vue-class-component'
import { map, tileLayer, marker, LeafletMouseEvent, icon, LayerGroup, layerGroup, LatLng } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { Prop } from 'vue-property-decorator'

@Component
export default class LocationPicker extends Vue {
  @Prop({ default: { lat: 32.0749, lng: 34.7817 } }) value!: LatLng;
  map!: L.Map
  markers!: LayerGroup

  mounted () {
    this.map = map(this.$el as HTMLElement).setView([this.value.lat, this.value.lng], 13)
    tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png').addTo(this.map)
    this.map.on('click', this.handleMapClick)
    this.markers = layerGroup().addTo(this.map)
    this.addMarker(this.value)
    setTimeout(() => {
      this.map.invalidateSize()
    }, 100)
  }

  handleMapClick (e: LeafletMouseEvent) {
    this.markers.clearLayers()
    this.addMarker(e.latlng)
    this.$emit('input', {
      lat: e.latlng.lat,
      lng: e.latlng.lng
    })
  }

  private addMarker (latlng: LatLng) {
    marker([latlng.lat, latlng.lng],
      {
        icon: icon({
          iconRetinaUrl: require('leaflet/dist/images/marker-icon.png'),
          iconUrl: require('leaflet/dist/images/marker-icon.png'),
          shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
          iconAnchor: [14, 42]
        })
      }).addTo(this.markers)
  }
}
